const initialState = {
  openModalDebitValue: false,
  hasBeenReadModalUserMessageValue: false,
  valueAmountValue: 0,
  debitsValue: [],
  debitsSelectedValue: [],
  debitsSelectedIDsValue: [],
  debitsFilterPreferences: null,
  damValue: [],
  damSelectedValue: [],
  damSelectedIDsValue: [],
  damTotalRegistrosValue: 0,
  damTotalPaginasValue: 0,
  damNumeroPaginaValue: 1,
  damTamanhoPaginaValue: 5,
  openSnackValue: false,
  openConfirmDialogValue: false,
  registerDebitAutomaticValue: [],
  noMixedBankDataValue: [],
  amountDueValue: -1,
  checkAllVincendoValue: false,
  currentPageAfterFilterValue: false,
  clearFilterDebit: false,
  clearFilterUnidadeDebit: false,
  rowsPerPage: 36,
  openBankInfos: {},
  acquirersActives: [],
  paymentCreditCardObject: {},
  acquirerSelected: {},
  backSelected: "",
  dateExpiration: 0,
  paymentDateValue: null,
  bankSelectedOnlinePayment: 0,
  listAdquirentes: [],
  selectedUser: "",
  messageValidation: ""
};

const checkVincendoDias = (state, checkAllVincendoValue) => {
  return { ...state, checkAllVincendoValue: checkAllVincendoValue };
};

export const cardDebitReducer = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_MODAL_DEBIT":
      return { ...state, openModalDebitValue: action.openModalDebitValue };
    case "OPEN_MODAL_USER_MESSAGE":
      return {
        ...state,
        hasBeenReadModalUserMessageValue:
          action.hasBeenReadModalUserMessageValue,
      };
    case "VALUE_AMOUNT":
      return { ...state, valueAmountValue: action.valueAmountValue };
    case "FILTER_DEBITS":
      return { ...state, filterDebitsValue: action.filterDebitsValue };
    case "DEBITS_FILTER_PREFERENCES":
      return {
        ...state,
        debitsFilterPreferences: action.debitsFilterPreferences,
      };
    case "DEBITS":
      return { ...state, debitsValue: action.debitsValue };
    case "DEBITS_SELECTED":
      return { ...state, debitsSelectedValue: action.debitsSelectedValue };
    case "DEBITS_SELECTED_IDS":
      return {
        ...state,
        debitsSelectedIDsValue: action.debitsSelectedIDsValue,
      };
    case "DAM":
      return { ...state, damValue: action.damValue };
    case "DAM_SELECTED":
      return { ...state, damSelectedValue: action.damSelectedValue };
    case "DAM_SELECTED_IDS":
      return { ...state, damSelectedIDsValue: action.damSelectedIDsValue };
    case "DAM_TOTAL_REGISTROS":
      return {
        ...state,
        damTotalRegistrosValue: action.damTotalRegistrosValue,
      };
    case "DAM_TOTAL_PAGINAS":
      return { ...state, damTotalPaginasValue: action.damTotalPaginasValue };
    case "DAM_NUMERO_PAGINA":
      return { ...state, damNumeroPaginaValue: action.damNumeroPaginaValue };
    case "DAM_TAMANHO_PAGINA":
      return { ...state, damTamanhoPaginaValue: action.damTamanhoPaginaValue };
    case "OPEN_SNACK":
      return { ...state, openSnackValue: action.openSnackValue };
    case "OPEN_CONFIRM_DIALOG":
      return {
        ...state,
        openConfirmDialogValue: action.openConfirmDialogValue,
      };
    case "REGISTER_AUTOMATIC_DEBIT":
      return {
        ...state,
        registerDebitAutomaticValue: action.registerDebitAutomaticValue,
      };
    case "NO_MIXED_BANK_DATA":
      return { ...state, noMixedBankDataValue: action.noMixedBankDataValue };
    case "AMOUNT_DUE":
      return { ...state, amountDueValue: action.amountDueValue };
    case "CHECK_ALL_VINCENDO":
      return checkVincendoDias(state, action.checkAllVincendoValue);
    case "MODAL_SELECTED":
      return {
        ...state,
        modalFilterContribuitesValue: action.modalFilterContribuitesValue,
      };
    case "SET_CURRENT_PAGE_AFTER_FILTER":
      return {
        ...state,
        currentPageAfterFilterValue: action.currentPageAfterFilterValue,
      };
    case "SET_CLEAR_FILTER_DEBIT":
      return {
        ...state,
        clearFilterDebit: action.clearFilterDebit,
      };
    case "SET_CLEAR_FILTER_UNIDADE_DEBIT":
      return {
        ...state,
        clearFilterUnidadeDebit: action.clearFilterUnidadeDebit,
      };
    case "SET_ROWS_PER_PAGE":
      return {
        ...state,
        rowsPerPage: action.rowsPerPage,
      };
    case "OPEN_BANK_INFOS":
      return { ...state, openBankInfos: action.openBankInfos };
    case "ACQUIRERS_ACTIVES":
      return { ...state, acquirersActives: action.acquirersActives };
    case "PAYMENT_CREDIT_CARD_OBJECT":
      return {
        ...state,
        paymentCreditCardObject: action.paymentCreditCardObject,
      };
    case "BANK_SELECTED_ONLINE_PAYMENT":
      return {
        ...state,
        bankSelectedOnlinePayment: action.bankSelectedOnlinePayment,
      };
    case "ACQUIRER_SELECTED":
      return {
        ...state,
        acquirerSelected: action.acquirerSelected,
      };
    case "SET_EXPIRATION_DAY":
      return {
        ...state,
        dateExpiration: action.dateExpiration,
      };
    case "PAYMENT_DATE_VALUE":
      return {
        ...state,
        paymentDateValue: action.paymentDateValue,
      };
    case "LIST_ADQUIRENTES":
      return {
        ...state,
        listAdquirentes: action.listAdquirentes,
      };
    case "SET_SELECTED_USER_SEARCH":
      return {
        ...state,
        selectedUser: action.payload,
      };
    case "VALID_DEBITS_MESSAGE":
      return {
        ...state,
        messageValidation: action.payload,
      };

    default:
      return state;
  }
};
